var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gallery',{attrs:{"images":_vm.propsFile,"index":_vm.index},on:{"close":function($event){_vm.index = null}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }